export default __webpack_public_path__ + "static/staff-augmentation-home-banner-d0105be33434ff6bfecb89d41e2d4480.jpg";